<template>
  <div class="memberDetail" v-if="dialog.show">
    <el-dialog
      width="800px"
      :visible.sync="dialog.show"
      :close-on-click-modal="dialog.clickModal"
      :close-on-press-escape="dialog.pressEscape"
      @close='closeDialog'
      :modal-append-to-body="false"
    >
      <el-tabs tab-position="top">
        <el-tab-pane label="用户信息">
          <member :member="dialog.member" operation="edit"></member>
        </el-tab-pane>
        <el-tab-pane label="配镜信息">
          <consum-records :member="dialog.member"></consum-records>
        </el-tab-pane>
        <el-tab-pane label="回访记录">
          <msg-records :member="dialog.member"></msg-records>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Member from "./Member.vue";
import ConsumRecords from "./ConsumRecords.vue";
import MsgRecords from "./MsgRecords.vue";

export default {
  name: "memberDetail",
  props: {
    dialog: Object
  },
  components: {
    Member,
    ConsumRecords,
    MsgRecords
  },
  data() {
    return {};
  },
  methods: {
    closeDialog(){
      this.$emit("refresh");
    }
  },
  created() {}
};
</script>
<style lang="scss">
.memberDetail {
  .el-dialog__headerbtn {
    z-index: 999;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__header {
    padding: 0px;
  }
}
</style>
